// safe check for host include tests
const hostIncludes = (req, value) => {
    const host = req.hostname || req.host || '';
    return host.includes(value);
};

const brandTests = [
    {
        brand: 'kbb',
        test: (req) => {
            let kbbHeaderValue;

            // KBB brand is determined from x-lst-route header on the server
            if (typeof req.header === 'function') {
                kbbHeaderValue = req.header('x-lst-route') || req.header('X-lst-route');
            }

            return kbbHeaderValue === 'atc' || hostIncludes(req, 'kbb.com') || req.query.brand === 'kbb';
        },
    },
    {
        brand: 'ford',
        test: (req) => {
            // Ford url needed to be broken up so that Googlebot cannot detect it as a full website address
            // and interpret it as a link from ATC/KBB to Ford
            const brand = 'fordblueadvantage';
            return hostIncludes(req, brand + '.com') || req.query.brand === 'ford';
        },
    },
    {
        brand: 'previewAtc',
        test: (req) => hostIncludes(req, 'preview.autotrader') || req.query.brand === 'previewAtc',
    },
    {
        brand: 'demo',
        test: (req) => req.query.brand === 'demo',
    },
    {
        brand: 'carAndDriver',
        test: (req) =>
            hostIncludes(req, 'caranddriver.com')
            || hostIncludes(req, 'hearstapps.net')
            || req.query.brand === 'carAndDriver',
    },
    {
        // ensure this is last in the array
        // so that brand defaults to Autotrader
        brand: 'atc',
        test: () => true,
    },
];

function parseTestSubdomainBrand(req) {
    let brand = 'demo';

    const excludeSubdomain = ['test', 'www'];

    if (Array.isArray(req.subdomains) && req.subdomains.length !== 0) {
        // set brand to be subdomain key(ford, test, etc)
        let [parsedBrand] = req.subdomains;

        // if somehow the test and www subdomain is added then we rewrite it to demo
        if (excludeSubdomain.includes(parsedBrand)) {
            parsedBrand = 'demo';
        }

        brand = parsedBrand;
    }

    return brand;
}

module.exports = function brandExpressMiddleware() {
    return (req, res, next) => {
        let brand;

        if (hostIncludes(req, 'atwhitelabel')) {
            brand = parseTestSubdomainBrand(req);
        } else {
            ({ brand } = brandTests.find(({ test }) => test(req)));
        }

        req.headers['x-internal-brand'] = brand;
        req.brand = brand;

        next();
    };
};
